import { render } from "./InvoiceDocuments.vue?vue&type=template&id=6c7bbff6&ts=true"
import script from "./InvoiceDocuments.vue?vue&type=script&lang=ts"
export * from "./InvoiceDocuments.vue?vue&type=script&lang=ts"

import exportComponent from "/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__